<template>
  <div id="cookie_banner"
       class="flex justify-center items-center absolute bottom-0 left-0 w-full bg-classen__secondary">
    <div id="banner_content" class="flex">
      <p>The Qube uses cookies to ensure you get the best experience and keeps you logged in.
        <a href="https://sensa-flooring.com/legal-notice">Read the legal notice</a>
      </p>
    </div>
    <button class="classen__button" @click="setAccepted">Accept</button>
  </div>
</template>
<script>

import getTranslation from "../../mixins/getTranslation";

export default {
  name: "CookieBanner",

  mixins: [getTranslation],

  methods: {
    setAccepted() {
      window.localStorage.setItem('cookieBanner', 'Accepted');
      this.$emit('accepted')
    }
  }
}
</script>

<style scoped>
.classen__button {
  line-height: 30px;
}

#cookie_banner {
  height: 50px;
}

#banner_content {
  width: 1000px;
}

p {
  line-height: 50px;
}
</style>
